import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CalendarDays, Loader2, ArrowRight, ArrowLeft } from "lucide-react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { WhatsAppFloat } from "../components/WhatsAppFloat";
import { resolveMedia } from "../siteContext";
import { useLang, pick } from "../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PostPage() {
  const { slug } = useParams();
  const { lang, s } = useLang();
  const [post, setPost] = useState(undefined);
  const Arrow = lang === "ar" ? ArrowRight : ArrowLeft;

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/posts/${slug}`).then((res) => setPost(res.data)).catch(() => setPost(null));
  }, [slug]);

  return (
    <div className="min-h-screen bg-luxury-black">
      <Header />
      <main className="pt-36 pb-28">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          {post === undefined ? (
            <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-luxury-gold animate-spin" /></div>
          ) : post === null ? (
            <div data-testid="post-not-found" className="text-center py-20 border border-luxury-border bg-luxury-surface rounded-2xl">
              <p className="text-luxury-gray mb-6">{lang === "ar" ? "هذا المقال غير موجود أو غير منشور" : "This post does not exist or is not published"}</p>
              <Link to="/blog" className="text-luxury-gold hover:text-luxury-goldLight transition-colors">{s.blog_back}</Link>
            </div>
          ) : (
            <motion.article data-testid="post-page" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
              <Link to="/blog" data-testid="post-back-link" className="inline-flex items-center gap-2 text-sm text-luxury-gray hover:text-luxury-gold transition-colors mb-10">
                <Arrow className="w-4 h-4" strokeWidth={1.5} />
                {s.blog_back}
              </Link>
              <p className="text-luxury-gray text-xs flex items-center gap-2 mb-4">
                <CalendarDays className="w-3.5 h-3.5 text-luxury-gold" strokeWidth={1.5} />
                {(post.created_at || "").slice(0, 10)}
              </p>
              <h1 data-testid="post-title" className="font-serif font-bold text-4xl sm:text-5xl text-luxury-bone leading-[1.3] mb-8">
                {pick(lang, post, "title")}
              </h1>
              {post.cover_image ? (
                <div className="rounded-3xl overflow-hidden border border-luxury-border mb-10">
                  <img data-testid="post-cover" src={resolveMedia(post.cover_image)} alt={pick(lang, post, "title")} className="w-full max-h-[420px] object-cover" />
                </div>
              ) : null}
              <div data-testid="post-content" className="text-luxury-bone/90 text-base md:text-lg leading-loose whitespace-pre-line">
                {pick(lang, post, "content")}
              </div>
            </motion.article>
          )}
        </div>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
